// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FileText, 
  Search, 
  Filter, 
  PlusCircle, 
  Clock, 
  CheckCircle, 
  XCircle, 
  AlertCircle, 
  Edit3,
  Ban,
  Loader2,
  Eye,
  Edit2,
  AlertTriangle,
  ChevronLeft,
  ChevronRight,
  Archive
} from "lucide-react";

// IMPORTAÇÕES DO FIREBASE E CONTEXTO
import { collection, query, where, onSnapshot, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../config/firebase"; 
import { useAuth } from "../../contexts/AuthContext";

const SolicitacoesPage = () => {
  const { companyInfo } = useAuth();
  
  // 🟢 Tipagem inserida para zerar os erros do TypeScript
  const [requests, setRequests] = useState(/** @type {any[]} */ ([]));
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  // 🟢 States de Paginação (Client-Side)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // ==========================================
  // BUSCA EM TEMPO REAL NO FIRESTORE + SUBCOLEÇÃO DE PARTES
  // ==========================================
  useEffect(() => {
    if (!companyInfo?.id) return;

    setLoading(true);

    // Query: Filtra pela empresa logada e ordena pelas mais recentes
    const q = query(
      collection(db, "requests"),
      where("companyId", "==", companyInfo.id),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      try {
        const fetchPromises = querySnapshot.docs.map(async (docSnapshot) => {
          const requestData = docSnapshot.data();
          const partesRef = collection(db, `requests/${docSnapshot.id}/partes`);
          const partesSnap = await getDocs(partesRef);
          
          // Filtra apenas as partes que são "Locatário" e extrai o nome
          const locatarios = partesSnap.docs
            .map(p => p.data())
            .filter(p => p.dadosPessoais?.pretendenteA === "Locatário")
            .map(p => p.dadosPessoais?.nome);

          return { 
            id: docSnapshot.id, 
            ...requestData, 
            locatarios 
          };
        });

        const resolvedDocs = await Promise.all(fetchPromises);
        setRequests(resolvedDocs);
      } catch (error) {
        console.error("Erro ao buscar subcoleções de partes:", error);
      } finally {
        setLoading(false);
      }
    }, (error) => {
      console.error("Erro ao listar requests:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [companyInfo?.id]);

  // 🟢 Reseta a página para 1 se pesquisar ou mudar a qtde de itens
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  const renderStatusBadge = (status) => {
    const badges = {
      "Em Cadastramento": { color: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800/50 dark:text-slate-300 dark:border-slate-700", icon: Edit3 },
      "Em Analise": { color: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800/50", icon: Clock },
      "Pendente": { color: "bg-yellow-100 text-yellow-700 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-400 dark:border-yellow-800/50", icon: AlertCircle },
      "Aprovada": { color: "bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800/50", icon: CheckCircle },
      "Rejeitada": { color: "bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800/50", icon: XCircle },
      "Cancelada Cliente": { color: "bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700 line-through decoration-gray-400", icon: Ban },
      "Legado": { color: "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-400 dark:border-purple-800/50", icon: Archive },
      "LEGADO": { color: "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-400 dark:border-purple-800/50", icon: Archive },
    };

    const config = badges[status] || badges["Em Analise"];
    const Icon = config.icon;

    return (
      <span className={`inline-flex items-center px-2.5 py-1 text-xs font-bold rounded-full border ${config.color} whitespace-nowrap`}>
        <Icon className="w-3.5 h-3.5 mr-1" />
        {status}
      </span>
    );
  };

  const filteredRequests = requests.filter(req => 
    req.protocolo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    req.imovel?.codigo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    req.imovel?.endereco?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const pendenciasCount = requests.filter(req => req.status === "Pendente").length;

  // ==========================================
  // 🟢 Fatiamento Paginação Client-Side
  // ==========================================
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredRequests.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);

  const nextPage = () => { if (currentPage < totalPages) setCurrentPage(prev => prev + 1); };
  const prevPage = () => { if (currentPage > 1) setCurrentPage(prev => prev - 1); };

  // ============================================================================
  // SKELETON LOADER (Suporte a Dark Mode)
  // ============================================================================
  if (loading) {
    return (
      <div className="p-4 sm:p-6 lg:p-8 space-y-6 animate-pulse bg-light-bg dark:bg-dark-bg min-h-screen">
        <div className="flex items-center gap-4 border-b border-light-border dark:border-dark-border pb-6">
           <div className="w-14 h-14 bg-slate-200 dark:bg-slate-800 rounded-xl shrink-0"></div>
           <div className="space-y-2"><div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-64"></div><div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-96"></div></div>
        </div>

        <div className="bg-light-card dark:bg-dark-card rounded-2xl border border-light-border dark:border-dark-border overflow-hidden mt-6">
          <div className="bg-light-bg/50 dark:bg-dark-bg/50 border-b border-light-border dark:border-dark-border h-16"></div>
          {Array(6).fill(0).map((_, i) => (
            <div key={i} className="flex justify-between items-center p-6 border-b border-light-border dark:border-dark-border">
              <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-32"></div>
              <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-48 hidden md:block"></div>
              <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-24"></div>
              <div className="h-6 bg-slate-200 dark:bg-slate-800 rounded-full w-28"></div>
              <div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-10"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6 animate-fade-in bg-light-bg dark:bg-dark-bg min-h-full font-sans overflow-x-hidden w-full">
      
      {/* HEADER E AÇÕES */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-light-border dark:border-dark-border pb-6">
        <div>
          <h1 className="text-3xl font-bold text-light-text-primary dark:text-dark-text-primary flex items-center">
            <FileText className="w-8 h-8 mr-3 text-brand-primary" />
            Solicitações
          </h1>
          <p className="text-light-text-secondary dark:text-dark-text-secondary mt-1">
            Gerencie todos as Solicitações de fiança da sua imobiliária.
          </p>
        </div>
        <Link 
          to="/dashboard/novo-request"
          className="flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-bold text-white bg-brand-primary hover:bg-teal-600 rounded-xl transition-all shadow-md shadow-brand-primary/30 shrink-0"
        >
          Nova Solicitação <PlusCircle className="w-4 h-4 ml-1" />
        </Link>
      </div>

      {/* BANNER DE URGÊNCIA */}
      {pendenciasCount > 0 && !loading && (
        <div className="bg-yellow-50 border border-yellow-200 dark:bg-yellow-900/20 dark:border-yellow-800/50 rounded-2xl p-4 flex items-start sm:items-center gap-4 shadow-sm animate-fade-in">
          <div className="p-2 bg-yellow-100 dark:bg-yellow-900/40 rounded-full shrink-0">
            <AlertTriangle className="w-6 h-6 text-yellow-600 dark:text-yellow-500" />
          </div>
          <div>
            <h3 className="font-bold text-yellow-800 dark:text-yellow-500 text-sm sm:text-base">
              Ação Necessária
            </h3>
            <p className="text-sm text-yellow-700 dark:text-yellow-400 mt-0.5">
              Você possui <strong className="font-black">{pendenciasCount}</strong> Solicitação(ões) pendente(s). Clique no lápis (<Edit2 className="w-3 h-3 inline mx-0.5" />) para editar e reenviar as fichas destacadas abaixo.
            </p>
          </div>
        </div>
      )}

      {/* ÁREA DE LISTAGEM */}
      <div className="bg-light-card dark:bg-dark-card rounded-2xl border border-light-border dark:border-dark-border shadow-sm flex flex-col w-full max-w-full overflow-hidden">
        
        {/* BARRA DE FILTROS */}
        <div className="p-5 border-b border-light-border dark:border-dark-border flex flex-col sm:flex-row justify-between items-center gap-4 bg-light-bg/50 dark:bg-dark-bg/50 shrink-0">
          <div className="flex gap-2 w-full sm:w-auto flex-1">
            <div className="relative flex-1 max-w-md">
              <Search className="w-4 h-4 absolute left-3 top-3 text-light-text-secondary dark:text-dark-text-secondary" />
              <input 
                type="text" 
                placeholder="Pesquisar protocolo ou endereço..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-9 pr-4 py-2 bg-light-card dark:bg-dark-card border-b-2 border-transparent hover:border-light-border focus:border-brand-primary text-sm focus:outline-none text-light-text-primary dark:text-dark-text-primary transition-all"
              />
            </div>
            <button className="flex items-center justify-center p-2 text-light-text-secondary hover:text-brand-primary transition-colors">
              <Filter className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* TABELA */}
        <div className="overflow-x-auto w-full min-h-[300px] flex flex-col relative custom-scrollbar flex-1">
          {filteredRequests.length === 0 ? (
            <div className="flex-1 flex flex-col items-center justify-center p-12 text-center">
              <div className="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4">
                <FileText className="w-8 h-8 text-slate-400" />
              </div>
              <p className="text-light-text-primary dark:text-dark-text-primary font-bold">Nenhuma Solicitação encontrado nesta página.</p>
              <p className="text-sm text-light-text-secondary mt-1">Ajuste os filtros ou crie uma nova Solicitação.</p>
            </div>
          ) : (
            <table className="w-full text-left border-collapse min-w-[700px]">
              <thead>
                <tr className="bg-light-bg dark:bg-dark-bg border-b border-light-border dark:border-dark-border text-[11px] uppercase text-light-text-secondary dark:text-dark-text-secondary font-bold tracking-wider leading-tight">
                  <th className="p-4 pl-6 w-[12%] whitespace-nowrap">Solicitação</th>
                  <th className="p-4 w-[10%]">Código do Imóvel</th>
                  <th className="p-4 w-[28%]">Endereço</th>
                  <th className="p-4 w-[18%]">Locatários</th>
                  <th className="p-4 w-[10%]">Atendente</th>
                  <th className="p-4 w-[10%]">Data Solicitação</th>
                  <th className="p-4 w-[10%] whitespace-nowrap">Situação</th>
                  <th className="p-4 pr-6 text-right w-[2%] whitespace-nowrap">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-light-border dark:divide-dark-border">
                {currentItems.map((req) => {
                  
                  const isPendente = req.status === "Pendente";
                  const rowClasses = isPendente 
                    ? "bg-yellow-50/50 dark:bg-yellow-900/10 border-l-4 border-l-yellow-400 hover:bg-yellow-100/50 dark:hover:bg-yellow-900/20 transition-colors group" 
                    : "hover:bg-light-bg/50 dark:hover:bg-dark-bg/50 border-l-4 border-l-transparent transition-colors group";

                  const enderecoCompleto = req.imovel?.endereco 
                    ? `${req.imovel.endereco}, ${req.imovel.numero} - ${req.imovel.bairro}, ${req.imovel.cidade}/${req.imovel.estado}` 
                    : "-";

                  return (
                    <tr key={req.id} className={rowClasses}>
                      <td className="p-4 pl-5 align-top pt-5 whitespace-nowrap">
                        <Link 
                          to={`/dashboard/request/${(req.protocolo || req.numeroSolicitacao || req.id).replace('/','-')}`} 
                          className="font-bold text-brand-primary hover:underline whitespace-nowrap"
                        >
                          {req.protocolo || req.numeroSolicitacao || "S/N"}
                        </Link>
                      </td>
                      <td className="p-4 text-sm font-medium text-light-text-primary dark:text-dark-text-primary align-top pt-5 whitespace-nowrap">
                        {req.imovel?.codigo || "-"}
                      </td>
                      <td className="p-4 text-sm text-light-text-secondary dark:text-dark-text-secondary pr-4 align-top pt-5 leading-relaxed">
                        {enderecoCompleto}
                      </td>
                      <td className="p-4 text-sm font-bold text-light-text-primary dark:text-dark-text-primary align-top pt-5">
                        {req.locatarios && req.locatarios.length > 0 ? (
                          <div className="flex flex-wrap items-center gap-1.5">
                            <span>{req.locatarios[0]}</span>
                            {req.locatarios.length > 1 && (
                              <span className="text-[10px] bg-brand-primary/10 text-brand-primary px-1.5 py-0.5 rounded-full whitespace-nowrap">
                                +{req.locatarios.length - 1}
                              </span>
                            )}
                          </div>
                        ) : (
                          <span className="text-light-text-secondary dark:text-dark-text-secondary font-normal italic">
                            Não informado
                          </span>
                        )}
                      </td>
                      <td className="p-4 text-sm text-light-text-secondary dark:text-dark-text-secondary align-top pt-5 leading-snug">
                        {req.createdByName || "Sistema"}
                      </td>
                      <td className="p-4 text-sm text-light-text-secondary dark:text-dark-text-secondary align-top pt-5 leading-snug">
                        {req.dataSolicitacaoTexto || "-"}
                      </td>
                      <td className="p-4 align-top pt-5 whitespace-nowrap">
                        {renderStatusBadge(req.status)}
                      </td>
                      <td className="p-4 pr-6 text-right align-top pt-4 whitespace-nowrap">
                        <div className="flex items-center justify-end gap-2">
                          <Link 
                            to={`/dashboard/request/${(req.protocolo || req.numeroSolicitacao || req.id).replace('/','-')}`}
                            className="p-1.5 text-light-text-secondary hover:text-brand-primary bg-light-bg dark:bg-dark-bg border border-light-border dark:border-dark-border hover:border-brand-primary/30 rounded-lg transition-all"
                            title="Visualizar Ficha"
                          >
                            <Eye className="w-4 h-4" />
                          </Link>
                          
                          {isPendente && (
                            <Link 
                              to={`/dashboard/novo-request/${(req.protocolo || req.numeroSolicitacao || req.id).replace('/','-')}`}
                              className="p-1.5 text-yellow-600 bg-yellow-50 hover:bg-yellow-100 dark:bg-yellow-900/20 dark:text-yellow-500 border border-yellow-200 dark:border-yellow-800/50 hover:border-yellow-400 rounded-lg transition-all shadow-sm relative"
                              title="Editar Pendências"
                            >
                              <Edit2 className="w-4 h-4" />
                              <span className="absolute -top-1 -right-1 flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-500"></span>
                              </span>
                            </Link>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        
        {/* 🟢 RODAPÉ DA TABELA (PAGINAÇÃO VIVA E RESPONSIVA) */}
        {filteredRequests.length > 0 && (
          <div className="p-4 border-t border-light-border dark:border-dark-border bg-light-bg/50 dark:bg-dark-bg/50 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-light-text-secondary dark:text-dark-text-secondary shrink-0">
            <span className="font-medium text-center md:text-left">
              Mostrando <strong className="text-light-text-primary dark:text-dark-text-primary">{indexOfFirstItem + 1}</strong> a <strong className="text-light-text-primary dark:text-dark-text-primary">{Math.min(indexOfLastItem, filteredRequests.length)}</strong> de <strong className="text-light-text-primary dark:text-dark-text-primary">{filteredRequests.length}</strong> Solicitações
            </span>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
              <div className="flex items-center gap-2 bg-light-card dark:bg-dark-card px-3 py-1.5 rounded-lg border border-light-border dark:border-dark-border shadow-sm w-full sm:w-auto justify-center">
                <span className="font-medium">Itens por página:</span>
                <select 
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="bg-transparent border-none font-bold text-brand-primary focus:ring-0 cursor-pointer text-sm outline-none"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </div>

              {totalPages > 1 && (
                <div className="flex items-center gap-2 justify-center w-full sm:w-auto">
                  <button 
                    onClick={prevPage}
                    disabled={currentPage === 1}
                    className="p-1.5 rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card hover:bg-light-bg dark:hover:bg-dark-bg disabled:opacity-50 transition-colors shadow-sm text-light-text-secondary dark:text-dark-text-secondary"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <span className="text-sm font-bold text-light-text-primary dark:text-dark-text-primary px-3 py-1 bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border rounded-lg shadow-sm">
                    {currentPage} / {totalPages}
                  </span>
                  <button 
                    onClick={nextPage}
                    disabled={currentPage >= totalPages}
                    className="p-1.5 rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card hover:bg-light-bg dark:hover:bg-dark-bg disabled:opacity-50 transition-colors shadow-sm text-light-text-secondary dark:text-dark-text-secondary"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default SolicitacoesPage;